import fetch from 'auth/FetchInterceptor'

const AuthService = {}


AuthService.login = function (data) {
  
  return fetch({
    url: '/auth/login',
    method: 'post',
    data: data
  });
}

AuthService.resetPassword = function (data) {
  
  return fetch({
    url: '/auth/reset-password',
    method: 'post',
    data: data
  });
}

AuthService.updatePassword = function (data) {
  
  return fetch({
    url: '/auth/update-password',
    method: 'post',
    data: data
  });
}

AuthService.updateProfile = function (data) {

  return fetch({
    url: '/auth/update-user',
    method: 'post',
    data: data
  });
}

AuthService.updatePreferences = function (data) {
  return fetch({
    url: '/auth/preferences',
    method: 'post',
    data: data,
  });
}


AuthService.updateProfileImage = function (data) {
  
  return fetch({
    url: '/auth/update-profile-image',
    method: 'post',
   'Content-Type': 'multipart/form-data',
    data: data
  });
  };

AuthService.resetPasswordS2 = function (data) {
  
  return fetch({
    url: '/auth/reset-password-s2',
    method: 'post',
    data: data
  });
}

AuthService.me = function () {
  
  return fetch({
    url: '/auth/me',
    method: 'get',
 
  });
}



export default AuthService;